class FeaturedCollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.waitForSwiper().then(() => {
      this.initializeSlider();
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  waitForSwiper() {
    return new Promise((resolve) => {
      const checkSwiper = () => {
        if (window.Swiper) {
          resolve();
        } else {
          setTimeout(checkSwiper, 100);
        }
      };
      checkSwiper();
    });
  }

  initializeSlider() {
    const swiperElement = this.querySelector('.featured-products-slider.swiper');
    
    if (!swiperElement || !window.Swiper) {
      console.warn('Swiper element or library not found');
      return;
    }

    try {
      this.swiper = new Swiper(swiperElement, {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 20,
        loop: true,
        speed: 800,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        keyboard: {
          enabled: true,
        },
        a11y: {
          enabled: true,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
          480: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 24,
          }
        },
        on: {
          init: () => {
            console.log('Featured Collection Slider initialized');
          },
          slideChange: () => {
            // Optional: Add any slide change effects here
          }
        }
      });

    } catch (error) {
      console.error('Error initializing featured collection slider:', error);
    }
  }

  // Public methods for external control
  nextSlide() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  goToSlide(index) {
    if (this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  pauseAutoplay() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.pause();
    }
  }

  resumeAutoplay() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.resume();
    }
  }

  updateSlider() {
    if (this.swiper) {
      this.swiper.update();
    }
  }
}

// Register the custom element
if (!customElements.get('featured-products-slider')) {
  customElements.define('featured-products-slider', FeaturedCollectionSlider);
} 